import React from 'react';
import { GrowRight } from '@elliemae/ds-shared';

const ToolBarAnimation = (props) => <GrowRight {...props} key="popper-animation-key" from={0.5} to={1} />;

export { ToolBarAnimation };
